<app-header></app-header>
<section class="inerpages-banner">
  <img src="{{ imgurl }}{{ bnrAr['picture'] }}" class="w-100" /> 

  <div class="fade-bg"></div>
  <div class="mask-content-v-center text-center">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div
            class="tbox-iner text-center animate zoomIn"
            data-anim-type="zoomIn"
          >
            <div class="heading-iner">
              <h2 *ngIf="showLang == 'en'">{{ bnrAr["smallCaption"] }}</h2>
              <h2 *ngIf="showLang == 'ar'">{{ bnrAr["smallCaption_ar"] }}</h2>

              <hr />
              <p *ngIf="showLang == 'en'">{{ bnrAr["bigCaption"] }}</p>
              <p *ngIf="showLang == 'ar'">{{ bnrAr["bigCaption_ar"] }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="cart-page about_bg py-3 py-md-5">
  <div class="container">
    <div class="row" *ngIf="storedCart; else emptyCart">
      <div class="col-md-9 pr-md-4">
        <h5 class="main-hedding">{{ "cart.shopping_cart" | translate }}</h5>

        <div class="card shopping-card">
          <div class="table-responsive">
            <table class="table" id="cart">
              <thead>
                <tr>
                  <th>{{ "cart.product" | translate }}</th>
                  <th>{{ "cart.quantity" | translate }}</th>
                  <th class="text-center">{{ "cart.subtotal" | translate }}</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="align-items-center my-4"
                  *ngFor="let cart of storedCart; index as i"
                >
                  <td data-th="Product" width="45%">
                    <div class="row">
                      <div class="col-sm-4 col-12 hidden-xs">
                        <a routerLink="{{ cart.pUrl }}">
                          <img
                            src="{{ imgurl }}{{ cart.pImage }}"
                            alt="Product 1"
                            width="160"
                            class="img-fluid wi-100 img-thumbnail"
                        /></a>
                      </div>
                      <div class="col-sm-8 col-12">
                        <h4 class="nomargin">
                          <a routerLink="{{ cart.pUrl }}">
                            <span *ngIf="showLang == 'en'">{{
                              cart.pName
                            }}</span>
                            <span *ngIf="showLang == 'ar'">{{
                              cart.pName_ar
                            }}</span>
                          </a>
                        </h4>
                        <span class="prodprice">
                          AED {{ cart.basePrice }}
                        </span>



      <div class="addonvalue" *ngIf="cart.newVariant && cart.newVariant.length > 0">
        <div *ngFor="let newVariant of cart.newVariant; let vi = index" class="mb-2">
          <div *ngIf="showLang == 'en'"><strong>  {{newVariant[0]['optionname']}} </strong></div>
          <div *ngIf="showLang == 'ar'"><strong> {{newVariant[0]['optionname_ar']}} </strong></div>

          <div *ngFor="let opval of newVariant" class="pl-1">
            <span *ngIf="showLang == 'en'"> 
              {{ opval.optvaluename }}-{{ opval.ovqty ? "Qty:" : "" }}
              {{ opval.ovqty}}</span>
            <span *ngIf="showLang == 'ar'">{{opval.optvaluename_ar}}</span>
            <span *ngIf="opval.ovprice != 0">, AED {{ opval.ovprice}}</span>
            <br>
          </div>
        </div>
      </div>

      <div class="addonvalue" *ngIf="cart.addons && cart.addons.length > 0">
        <div *ngIf="showLang == 'en'"><strong>Add</strong></div>
        <div *ngIf="showLang == 'ar'"><strong> يضيف </strong></div>
        <div *ngFor="let addon of cart.addons" class="pl-1">
          <span *ngIf="showLang == 'en'">{{addon.valuename}}</span>
          <span *ngIf="showLang == 'ar'">{{addon.valuename_ar}}</span>
          <span class="pl-1">-AED {{ addon.addonprice }} </span>
        </div>
      </div>

      <div class="addonvalue" *ngIf="cart.ingradients != ''">
        <p *ngFor="let garde of cart.ingradients">
          {{ garde.selectedvalue }} {{ garde.ingName }}
        </p>
      </div>

      <div class="addonvalue" *ngIf="cart.pComent && cart.pComent != ''">
        <p><span>Additional Instruction:</span>{{ cart.pComent }}</p>
      </div>

                      </div>
                    </div>
                  </td>

                  <td data-th="Quantity" width="20%">
                    <button
                      class="qtybtnmin"
                      (click)="desQty(cart.qty, cart.pId, cart.priceWithaddon,cart?.varients,cart?.addons,cart?.sno)"
                    >
                      -
                    </button>
                    <span class="qty">{{ cart.qty }}</span>
                    <button
                      class="qtybtnplus"
                      (click)="incQty(cart.qty, cart.pId, cart.priceWithaddon,cart?.varients,cart?.addons,cart?.sno)"
                    >
                      +
                    </button>
                  </td>
                  <td
                    width="20%"
                    data-th="Subtotal"
                    class="text-center main-price"
                  >
                    AED {{ cart.totalPrice }}
                  </td>
                  <td width="20%" class="actions text-right" data-th="">
                    <button
                      class="btn btn-danger del-btn btn-sm"
                      (click)="removeCart(i)"
                    >
                      <i class="fas fa-trash-alt" aria-hidden="true"></i>
                    </button>
                    <!-- <a
                      class="ml-2 edit-btncart btn btn-primary btn-sm"
                      href="#productDetail"
                      data-toggle="modal"
                      (click)="
                        customize(
                          cart.pslug,
                          cart.catslug,
                          cart.qty,
                          cart.pId,
                          cart.priceWithaddon,
                          cart.pUrl
                        )
                      "
                      data-target="#productDetail"
                      ><i class="fas fa-pencil-alt"></i
                    ></a> -->
                    
                    <a class="ml-2 edit-btncart btn btn-primary btn-sm"
                      ><i class="fas fa-pencil-alt"></i
                    ></a>



                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="align-items-center">
                  <td colspan="2" class="ps-reltive">
                    <form class="form-inline coupon-sec">
                      <div class="form-group mb-0 mr-2">
                        <input
                          type="text"
                          class="form-control"
                          id="coupon"
                          placeholder="{{ 'cart.enter_code' | translate }}"
                          #cpn
                        />
                      </div>
                      <button
                        type="submit"
                        (click)="applyCoupon(cpn.value)"
                        class="btn btn-primary"
                      >
                        {{ "cart.apply" | translate }}
                        <span *ngIf="isLoading">
                          <i class="fas fa-circle-notch fa-spin"></i>
                        </span>
                      </button>
                    </form>
                    <div
                      class="cpnsuccess"
                      *ngIf="iscpnApplied && showLang == 'en'"
                    >
                      {{ cpnMsg }}
                    </div>
                    <div
                      class="cpnerror"
                      *ngIf="!iscpnApplied && showLang == 'en'"
                    >
                      {{ cpnMsg }}
                    </div>

                    <div
                      class="cpnsuccess"
                      *ngIf="iscpnApplied && showLang == 'ar'"
                    >
                      {{ cpnMsg_ar }}
                    </div>
                    <div
                      class="cpnerror"
                      *ngIf="!iscpnApplied && showLang == 'ar'"
                    >
                      {{ cpnMsg_ar }}
                    </div>
                    <p class="cpn-altxt pl-0 mt-2 text-danger" *ngIf="showLang == 'en'"  >*Coupon does not apply on offer items</p>
                    <p class="cpn-altxt pl-0 mt-2 text-danger"*ngIf="showLang == 'ar'"  >*القسيمة لا تنطبق على عناصر العرض</p>
                  </td>

                  <td
                    colspan="2"
                    valign="middle"
                    class="hidden-xs cart-tot text-right"
                  >
                    <strong
                      >{{ "cart.total" | translate }} AED
                      {{ this.finalAmount }}</strong
                    >
                  </td>
                </tr>

                <tr>
                  <td colspan="4">
                    <button (click)="goBackPage()" class="btn Shopping-btn">
                      <i class="fa fa-angle-left" aria-hidden="true"></i>
                      {{ "cart.continue_shopping" | translate }}
                    </button>
                  </td>
                </tr>
              </tfoot>
            </table>

            <!-- EDIT CART ITEM POPUP -->

            <div class="mb-3">
              <div
                class="modal fade"
                id="productDetail"
                tabindex="-1"
                role="dialog"
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true"
              >
                <div
                  class="modal-dialog modal-lg modal-dialog-centered"
                  role="document"
                >
                  <div class="modal-content discover_products">
                    <div class="modal-header">
                      <h5
                        class="modal-title main-heading"
                        *ngIf="showLang == 'en'"
                      >
                        {{ productAr.pName }}
                      </h5>
                      <h5
                        class="modal-title main-heading"
                        *ngIf="showLang == 'ar'"
                      >
                        {{ productAr.pName_ar }}
                      </h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body pt-3 products_secs details-page">
                      <div
                        class="col-lg-12 product-details col-md-6 mb-md-3 mb-0"
                      >
                        <div class="row">
                          <div class="card">
                            <div class="container-fliud">
                              <div class="row">
                                <div class="col-md-4">
                                  <img
                                    class="w-100 img-fluid"
                                    src="{{ imgurl }}{{ productAr.pImage }}"
                                  />
                                </div>
                                <div class="details col-md-8">
                                  <p *ngIf="showLang == 'en'">
                                    {{ productAr.pdescription }}
                                  </p>
                                  <p *ngIf="showLang == 'ar'">
                                    {{ productAr.pdescription_ar }}
                                  </p>
                                  <form class="form-inline quantity">
                                    <div class="form-group">
                                      <label class="mr-3" for="quantity">{{
                                        "cart.quantity" | translate
                                      }}</label>
                                      <button
                                        class="qtybtnmin"
                                        (click)="
                                          desQtyModel(
                                            this.qty,
                                            productAr['price']
                                          )
                                        "
                                      >
                                        -
                                      </button>
                                      <span class="qty">{{ this.qty }}</span>
                                      <button
                                        class="qtybtnplus"
                                        (click)="
                                          incQtyModel(
                                            this.qty,
                                            productAr['price'],
                                            productAr.pcategory_id,
                                            productAr.pQty
                                          )
                                        "
                                      >
                                        +
                                      </button>
                                    </div>
                                  </form>
                                  <div class="row my-md-4 my-2">
                                    <div
                                      class="col-md-6"
                                      *ngIf="productAr.poptions != ''">
                                      <div
                                        class="option"
                                        *ngFor="
                                          let optn of productAr.poptions;
                                          let i = index
                                        "
                                      >
                                        <h6 *ngIf="showLang == 'en'">
                                          {{ optn.option_display_name }}
                                        </h6>
                                        <h6 *ngIf="showLang == 'ar'">
                                          {{ optn.option_display_name_ar }}
                                        </h6>
                                        <div *ngIf="displName == optn.option_display_name ">
                                          <p *ngIf="minQtyMsg" style="font-size: 13px;" class="text-danger mt-2 text-sm">
                                            {{ minQtyMsg }}
                                          </p>
                                          </div>

                                        <div class="form-check mb-2 optncnt" *ngFor="let opv of optn.poptionvalues">

                                          <input
                                          type="radio"
                                          class="form-check-input optnchk"
                                          *ngIf="optn.isMultiSelect != 1"
                                          [attr.ischecked]="'no'"
                                          appEditcartradio
                                          name="optn{{ optn.id }}"
                                          id="opv{{ opv.id }}"
                                          [attr.optnname]="optn.option_name"
                                          [attr.optnname_ar]="optn.option_display_name_ar"
                                          [attr.optnid]="optn.id"
                                          [attr.optnvalue]="opv.ovalue"
                                          [attr.optnvalue_ar]="opv.ovalue_ar"
                                          [attr.pid]="productAr.id"
                                          [attr.price]="opv.ovprice"
                                          [attr.qty]="optn.isRestricted == 1 ? 0 : 1"
                                          [attr.pvalue]="opv.id"
                                          value="{{ opv.id }}"
                                          (change)="chkoptvl(optvl)"
                                          #optvl
                                        />
              
                                        <input  
                                          type="checkbox"
                                          class="form-check-input optnchk"
                                          *ngIf="optn.isMultiSelect == 1"
                                          [attr.ischecked]="'no'"
                                          appEditcartradio
                                          name="optn{{ opv.id }}"
                                          id="opv{{ opv.id }}"
                                          [attr.optnname]="optn.option_name"
                                          [attr.optnname_ar]="optn.option_display_name_ar"
                                          [attr.optnid]="optn.id"
                                          [attr.optnvalue]="opv.ovalue"
                                          [attr.optnvalue_ar]="opv.ovalue_ar"
                                          [attr.pid]="productAr.id"
                                          [attr.price]="opv.ovprice"
                                          [attr.qty]="optn.isRestricted == 1 ? 0 : 1"
                                          [attr.pvalue]="opv.id"
                                          value="{{ opv.id }}"
                                          (change)="chkoptvl(optvl2)"
                                          #optvl2
                                        /> 

                                        
                                        <form class="quantity quantityfrm" >
                                          <label class="form-check-label mb-1" for="opv{{ opv.id }}">
                                            <span *ngIf="showLang == 'en'">{{opv.ovalue}}</span>
                                            <span *ngIf="showLang == 'ar'">{{opv.ovalue_ar}}</span>
                                            <span *ngIf="opv.ovprice != 0">+ AED {{ opv.ovprice }}</span>
                                          </label>
              
                                          <div class="form-group overflow-hidden mb-0 indeccnt" *ngIf="optn.isRestricted == 1">
                                            <button appVariationbtn [dAction]="'substract'"  class="qtybtnmin qtybtn">-</button>
                                            <span class="qty optnqty">0</span>
                                            <button appVariationbtn [dAction]="'add'" class="qtybtnplus qtybtn">+</button>
                                          </div>
                                        </form>

                                        </div>
                                      </div>
                                    </div>

                                    <div
                                      class="col-md-6"
                                      *ngIf="productAr.padons != ''"
                                    >
                                      <div
                                        class="option"
                                        *ngFor="let adns of productAr.padons"
                                      >
                                        <h6 *ngIf="showLang == 'en'">
                                          {{ adns.adonDisName }}
                                        </h6>
                                        <h6 *ngIf="showLang == 'ar'">
                                          {{ adns.adonDisName_ar }}
                                        </h6>
                                        <div
                                          class="form-check"
                                          *ngFor="let adnv of adns.padonvalues"
                                        >
                                          <input
                                            class="form-check-input"
                                            type="checkbox"
                                            appAutochecked
                                            id="adon{{ adnv.id }}"
                                            [attr.adonname]="adns.adonName"
                                            [attr.adonid]="adns.id"
                                            [attr.valuename]="adnv.adonValue"
                                            [attr.valueid]="adnv.id"
                                            [attr.pid]="productAr.id"
                                            [attr.qty]="qty"
                                            value="{{ adnv.adonPrice }}"
                                            (change)="chkadonvl(adonvl)"
                                            #adonvl
                                          />
                                          <label
                                            class="form-check-label"
                                            for="adon{{ adnv.id }}"
                                          >
                                            <span *ngIf="showLang == 'en'">{{
                                              adnv.adonValue
                                            }}</span> 
                                            <span *ngIf="showLang == 'ar'">{{
                                              adnv.adonValue_ar
                                            }}</span>
                                            <span>
                                              +{{ adnv.adonPrice }} AED
                                            </span>
                                          </label>
                                        </div>
                                      </div>
                                    </div>

                                    <div
                                      class="col-md-6"
                                      *ngIf="productAr.allingredients != ''"
                                    >
                                      <div
                                        class="option mb-2 mb-md-3"
                                        *ngFor="
                                          let ing of productAr.allingredients;
                                          let j = index
                                        "
                                      >
                                        <h6 *ngIf="showLang == 'en'">
                                          {{ ing.ingName }}
                                        </h6>
                                        <h6 *ngIf="showLang == 'ar'">
                                          {{ ing.ingName_ar }}
                                        </h6>

                                        <div class="form-check">
                                          <input
                                            class="form-check-input"
                                            checked
                                            type="radio"
                                            name="ing{{ ing.id }}"
                                            id="ing_{{ j }}"
                                            [attr.ischecked]="'no'"
                                            appEditcartingredient
                                            [attr.pid]="productAr.id"
                                            [attr.gradeName]="ing.ingName"
                                            [attr.gradeid]="ing.id"
                                            value="Regular"
                                            (change)="checkGradient(inGrade)"
                                            #inGrade
                                          />
                                          <label
                                            class="form-check-label"
                                            for="ing_{{ j }}"
                                          >
                                            {{
                                              "product_detail.regular"
                                                | translate
                                            }}
                                          </label>
                                        </div>

                                        <div class="form-check">
                                          <input
                                            class="form-check-input"
                                            type="radio"
                                            name="ing{{ ing.id }}"
                                            id="ing2_{{ j }}"
                                            [attr.ischecked]="'no'"
                                            appEditcartingredient
                                            [attr.pid]="productAr.id"
                                            [attr.gradeName]="ing.ingName"
                                            [attr.gradeid]="ing.id"
                                            value="Less"
                                            (change)="checkGradient(inGrade2)"
                                            #inGrade2
                                          />
                                          <label
                                            class="form-check-label"
                                            for="ing2_{{ j }}"
                                          >
                                            {{
                                              "product_detail.less" | translate
                                            }}
                                          </label>
                                        </div>
                                        <div class="form-check">
                                          <input
                                            class="form-check-input"
                                            type="radio"
                                            name="ing{{ ing.id }}"
                                            id="ing3_{{ j }}"
                                            [attr.ischecked]="'no'"
                                            appEditcartingredient
                                            [attr.pid]="productAr.id"
                                            [attr.gradeName]="ing.ingName"
                                            [attr.gradeid]="ing.id"
                                            value="Without"
                                            (change)="checkGradient(inGrade3)"
                                            #inGrade3
                                          />
                                          <label
                                            class="form-check-label"
                                            for="ing3_{{ j }}"
                                          >
                                            {{
                                              "product_detail.without"
                                                | translate
                                            }}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <p *ngIf="minQtyMsg" style="font-size: 13px;" class="text-danger mt-2 text-sm">
                            {{ minQtyMsg }}
                          </p> 
                        </div>
                      </div>
                    
                    </div>

                    <div class="products_secs details-page">
                      <div class="row product-details">
                        <div class="col-md-6">
                          <div class="action">
                            <p class="total mb-0">
                              {{ "product_detail.total" | translate }}
                            </p>
                            <p class="total-price">{{ finalprice }}</p>
                          </div>
                        </div>
                        <div class="col-md-6 text-right">
                          <button
                            class="add-to-cart btn btn-default"
                            type="button"
                            (click)="
                              saveCustomization(
                                productAr.pName,
                                productAr.id,
                                productAr.price,
                                finalprice,
                                qty,
                                productAr.pImage
                              )
                            "
                          >
                            {{ "product_detail.save" | translate }}
                            <span *ngIf="iscustomLoading">
                              <i class="fas fa-circle-notch fa-spin"></i>
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--  Model end hee  -->
          </div>
        </div>
      </div>
      <div class="col-md-3 p-md-0 ord-summery-box">
        <aside class="">
          <h3 class="ord-summery-heading">
            {{ "cart.order_summary" | translate }}
          </h3>
          <dl class="dlist-align">
            <dt>
              {{ "cart.cart_total" | translate }}:
              <span>{{ this.storedCart.length }}</span>
            </dt>
            <dd class="text-right">AED {{ this.total }}</dd>
          </dl>

          <dl class="dlist-align" *ngIf="discountedAmount">
            <dt>{{ "cart.discount" | translate }}</dt>
            <dd class="text-right">AED {{ discountedAmount }}</dd>
          </dl>
          <dl class="dlist-align h4">
            <dt>
              <strong> {{ "cart.total" | translate }}: </strong>
            </dt>
            <dd class="text-right">
              <strong>AED {{ this.finalAmount }}</strong>
            </dd>
          </dl>

          <p class="cutleryopt mb-2">
            <span> {{ "cart.cutlery_option" | translate }} : </span>
          </p>
          <p class="cutleryopt">
            <input
              type="radio"
              class="mr-1"
              value="no"
              name="cutlery"
              id="yescutlery"
              (click)="onCutleryCheck('no')"
              [checked]="cutlery == 'no'"
            />
            <label for="yescutlery">
              {{ "cart.donotsend_cutlery" | translate }}</label
            >
          </p>
          <p class="cutleryopt">
            <input
              type="radio"
              class="mr-1"
              value="yes"
              name="cutlery"
              id="nocutlery"
              (click)="onCutleryCheck('yes')"
              [checked]="cutlery == 'yes'"
            />
            <label for="nocutlery">{{
              "cart.pleasesend_cutlery" | translate
            }}</label>
          </p>

          <p *ngIf="shopStatus == 0">
            <a
              href="checkout"
              class="btn mt-2 Shopping-btn btn-block Cout-btn"
              >{{ "cart.checkout" | translate }}</a
            >
            <a
              href="guest-checkout"
              class="btn mt-2 Shopping-btn btn-block Cout-btn"
              *ngIf="showGuestCheck"
              >{{ "cart.checkout_as_guest" | translate }}</a
            >
          </p>
          <p *ngIf="shopStatus == 1" class="shop-closed">
            {{ "cart.shop_closed" | translate }}
          </p>
        </aside>
      </div>
    </div>
    <ng-template #emptyCart>
      <div class="text-center alert alert-success">
        {{ "cart.cart_empty" | translate }}
        <a class="alert-link" [routerLink]="['/order-online']">{{
          "cart.continue_shopping" | translate
        }}</a>
      </div>
    </ng-template>
  </div>
</section>

<!-- modelto open -->
<button
  type="button"
  [hidden]="true"
  class="btn btn-primary btn-sm"
  data-toggle="modal"
  data-target="#modalPopup"
  #cmodel
></button>

<!-- Modal -->
<div
  class="modal alert-modal fade"
  id="modalPopup"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <button
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
        #closeBtn
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="modal-body text-center">
        <p *ngIf="showLang == 'en'">{{ cartMsg }}</p>
        <p *ngIf="showLang == 'ar'">{{ cartMsg_ar }}</p>
      </div>
    </div>
  </div>
</div>
